import * as React from "react";
const SvgFacebook = (props) => (
  <svg
    viewBox="0 0 12 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m11.103 12.374.627-3.98H7.867V5.809c0-1.088.539-2.152 2.263-2.152h1.78V.267A21.598 21.598 0 0 0 8.777 0C5.598 0 3.523 1.909 3.523 5.36v3.035H0v3.98h3.523V22h4.345v-9.626h3.235Z"
      fill="#fff"
    />
  </svg>
);
export default SvgFacebook;
